module.exports = __webpack_public_path__ + "static/img/service2.cb9ffd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service2.jpg
// module id = FJQj
// module chunks = 13